// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Severity chip (P1–P4) with the mock's status glyph: filled disc (P1/P2),
// hollow ring (P3), small dot (P4). Label/glyph geometry from
// theme/severity.ts; the chip's own color/background is a class from the
// sibling CSS module.

import React from 'react';
import type { Severity } from '../../../types/alarm';
import { severityStyle, sevIconGeom } from '../../../theme/severity';
import styles from './SeverityChip.module.css';

const SEV_CLASS: Record<Severity, string> = {
  P1: styles.p1,
  P2: styles.p2,
  P3: styles.p3,
  P4: styles.p4,
  Unknown: styles.unknown,
};

export function SeverityChip({ sev, size = 11 }: { sev: Severity; size?: number }) {
  const s = severityStyle(sev);
  const g = sevIconGeom(s.icon, s.accent);
  return (
    <span className={`hs-sev-chip ${SEV_CLASS[sev] ?? styles.unknown}`} data-sev={sev}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        style={{ flex: '0 0 auto' }}
        aria-hidden="true"
      >
        <circle cx="8" cy="8" r={g.r} fill={g.fill} stroke={g.stroke} strokeWidth={g.strokeWidth} />
      </svg>
      {s.tag}
    </span>
  );
}

export default SeverityChip;
